import React, { useState, useEffect } from 'react';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';
import { Card, CardBody, Col } from 'reactstrap';
import HomeExportOutlineIcon from 'mdi-react/HomeExportOutlineIcon';
import { Link } from 'react-router-dom';
import { _axiosCall } from '../../../../../shared/helpers/apicalls';
import ToolTip from '../../../../../shared/components/ToolTip';

const apiURL = process.env.API_ROOT + '/query/';

const CardPercent = ({ link, data, loaded }) => (
	<CardBody className={`${link ? 'chart__link' : ''} dashboard__health-chart-card`} style={{ padding: 10, borderRadius: 0 }}>
		<div className="card__title">
			<h5 className="card__title-center">
				{'% Absentee'}
				<ToolTip title={"Percent of units where the owner's mailing address differs from the unit address, indicating the owner does not live in the unit."} />
			</h5>
		</div>
		<div className="dashboard__health-chart">
			<ResponsiveContainer height={144}>
				<PieChart>
					<Pie data={data} dataKey="value" cy={58} innerRadius={54} outerRadius={63} />
				</PieChart>
			</ResponsiveContainer>
			<div className="pie-chart-info">
				<HomeExportOutlineIcon style={{ fill: '#F5A623' }} />
				<h5 className="profile__chart-number">
					{!loaded ? '--' : data[0].value > 0
						? parseFloat((data[0].value / (data[0].value + (data[1].value || 0)) * 100)).toFixed(0) + '%'
						: '0%'}
				</h5>
				<div className="product-card__subtext">absentee</div>
			</div>
			<div className="product-card__subtext">{loaded ? `(${data[0].value || '0'} owners)` : '--'}</div>
		</div>
	</CardBody>
);

const AbsenteeOwner = (props) => {
	const { unitsRes, buildingRes, col, location } = props;
	const [absenteeCount, setAbsenteeCount] = useState(0);
	const [totalCount, setTotalCount] = useState(0);
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		if (!unitsRes || !unitsRes.length) return;

		const residentialUnits = unitsRes.filter(u => {
			const pt = (u.property_type || '').toLowerCase();
			// Mirror the Solr search_value for property_type=residential in _unitFilters
			return !pt || pt.includes('residential') || pt.includes('co-op') || pt.includes('coop') ||
				pt.includes('affordable') || pt.includes('dwelling') || pt.includes('timeshare') ||
				pt.includes('apartment') || pt === 'condo' || pt === 'condo unit' ||
				pt === 'resident manager unit' || (pt.includes('bulk') && pt.includes('condo'));
		});

		const oneYearAgo = Math.floor((Date.now() - 365 * 24 * 3600 * 1000) / 1000);
		const allKeys = [];
		residentialUnits.forEach(u => {
			if (u.last_sold_date && u.last_sold_date >= oneYearAgo) return;
			if (u.key) allKeys.push(u.key);
			if (u.alternate_keys && Array.isArray(u.alternate_keys)) {
				u.alternate_keys.forEach(ak => allKeys.push(ak));
			}
		});
		if (!allKeys.length) return;

		_axiosCall({
			url: apiURL + 'dof-tax-bills?cache=120',
			method: 'post',
			query: {
				q: 'absentee_owner:true',
				fq: [`{!terms f=property}${allKeys.join(',')}`],
				rows: 0,
				wt: 'json',
				'json.facet': {
					unique_absentee: 'unique(property)'
				}
			}
		}).then(res => {
			if (res && res.facets) {
				const absentee = res.facets.unique_absentee || 0;
				const buildingTotal = buildingRes.inventory_total || buildingRes.total_units_sellable || buildingRes.total_units_residential || buildingRes.residential_units || buildingRes.total_units || residentialUnits.length;
				setAbsenteeCount(absentee);
				setTotalCount(buildingTotal);
				setLoaded(true);
			}
		}).catch(() => {});
	}, [unitsRes]);

	const data = [
		{ value: absenteeCount, fill: '#F5A623' },
		{ value: Math.max(0, totalCount - absenteeCount), fill: '#DBE0E8' },
	];

	return (
		<Col md={12} xl={col || 3} lg={6} sm={12} xs={12}>
			<Card>
				{location
					? <Link to={`${location.pathname.replace('/tab/overview', '')}/tab/units?group_view=list&owner=absentee&property_type=residential&unit_stage=all`}>
						<CardPercent data={data} loaded={loaded} link />
					</Link>
					: <CardPercent data={data} loaded={loaded} />
				}
			</Card>
		</Col>
	);
};

export default AbsenteeOwner;
